.panel {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 280px;
  padding: 8px 12px;
}

.row {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 36px;
}

.label {
  flex: 1 1 auto;
  font-size: 14px;
  line-height: 18px;
  color: var(--soft-text-2);
}

.slider {
  flex: 0 0 140px;
}

.play {
  flex: none;
}

.rule {
  height: 1px;
  margin: 4px 0;
  background: var(--soft-line);
}

.anchor {
  position: relative;
}

.popover {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 40;
}

/* /test/sounds — round 2: candidates grouped by event, the settings beside */
.stand {
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: 1120px;
  margin: 0 auto;
  padding: 32px 16px;
  font-family: var(--font-soft);
}

.standTitle {
  margin: 0;
  font-size: 22px;
  font-weight: var(--fw-num);
  line-height: 28px;
  color: var(--soft-text);
}

.standBody {
  display: flex;
  align-items: flex-start;
  gap: 24px;
}

.standGroups {
  display: grid;
  flex: 1 1 auto;
  grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
  gap: 8px;
  min-width: 0;
}

.standGroup {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 16px;
  border-radius: var(--soft-radius-card);
  background: var(--soft-block);
}

.groupTitle {
  margin: 0 0 8px;
  font-size: 14px;
  font-weight: var(--fw-num);
  line-height: 20px;
  color: var(--soft-text);
}

.option {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 36px;
}

.optionPlay.optionPlay {
  flex: none;
  gap: 6px;
  min-width: 52px;
  height: 32px;
  padding: 0 12px 0 10px;
  font-size: 13px;
}

/* the candidate that plays today: the chosen segment's ground and ink */
.optionPlay.optionPlay[aria-pressed="true"] {
  background: var(--soft-seg-on);
  color: #ffffff;
}

.optionAbout {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 13px;
  font-weight: var(--fw-label);
  line-height: 18px;
  color: var(--soft-text-2);
}

.optionCredit {
  flex: none;
  font-size: 12px;
  font-weight: var(--fw-label);
  line-height: 16px;
  color: var(--soft-muted);
  text-decoration: none;
}

a.optionCredit:hover {
  color: var(--soft-accent-ink);
}

.standPanel {
  position: sticky;
  top: 16px;
  flex: none;
}
